import { useEffect, useState } from 'react';
import { notification, Button, Form, Modal, Select } from 'antd';
import ApiService from '../../../services/ApiService';

export const SchoolAdminModal = ({ school, members, admin, onClose, onSave }) => {
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const [isSubmitting, setSubmitting] = useState(false);

  const memberOptions = members.map(member => ({
    label: `${member.firstName} ${member.lastName} (${member.userName})`,
    value: member.userId,
  }));

  const onFinish = async values => {
    setSubmitting(true);
    try {
      await ApiService.addSchoolAdmin(school.schoolId, values.userId);
      onSave();
    } catch (e) {
      api.open({
        message: 'Sorry...',
        description: 'Something went wrong...',
      });
    }
    setSubmitting(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [form, admin]);

  return (
    <Modal
      title="Add Admin"
      open={!!admin}
      onCancel={onClose}
      footer={[
        <Button key="save" type="primary" loading={isSubmitting} onClick={() => form.submit()}>
          Add
        </Button>,
      ]}
    >
      {contextHolder}
      <Form
        layout="vertical"
        initialValues={admin}
        form={form}
        onFinish={onFinish}
        requiredMark={false}
        autoComplete="off"
      >
        <Form.Item
          label="Admin"
          name="userId"
          rules={[
            {
              required: true,
              message: 'Admin is required!',
            },
          ]}
        >
          <Select showSearch placeholder="Select a admin" optionFilterProp="label" options={memberOptions} />
        </Form.Item>
        <Form.Item className="d-none">
          <Button type="primary" htmlType="submit"></Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
